import { render, staticRenderFns } from "./DevelopmentOverview.vue?vue&type=template&id=a0fec83a&scoped=true&"
import script from "./DevelopmentOverview.vue?vue&type=script&lang=js&"
export * from "./DevelopmentOverview.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentOverview.vue?vue&type=style&index=0&id=a0fec83a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fec83a",
  null
  
)

export default component.exports